import { useNavigate } from 'react-router-dom';

function SignalsNavigation({ activePage }) {
  const navigate = useNavigate();

  const navButtons = [
    { id: 'market-scan', label: '📊 Market Scan', path: '/signals' },
    { id: 'extended-crypto', label: '🔍 Extended Crypto', path: '/extended-crypto' },
    { id: 'individual-signals', label: '🎯 Individual Signals', path: '/individual-signals' },
  ];

  const activeStyle = {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    fontWeight: '600',
    boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
    transform: 'scale(1.02)',
  };

  const inactiveStyle = {
    background: '#1e293b',
    color: '#94a3b8',
    border: '1px solid #334155',
  };

  const baseStyle = {
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontSize: '0.9rem',
    transition: 'all 0.2s ease',
    border: 'none',
    flex: '1',
    minWidth: '120px',
    textAlign: 'center',
  };

  return (
    <div style={{ 
      background: '#0f172a', 
      padding: '1rem',
      borderBottom: '1px solid #1e293b'
    }}>
      <div className="container">
        {/* Desktop: Horizontal layout */}
        <div 
          className="nav-desktop"
          style={{ 
            display: 'flex', 
            gap: '0.75rem', 
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}
        >
          {navButtons.map((btn) => (
            <button
              key={btn.id}
              onClick={() => navigate(btn.path)}
              style={{
                ...baseStyle,
                ...(activePage === btn.id ? activeStyle : inactiveStyle),
              }}
              onMouseEnter={(e) => {
                if (activePage !== btn.id) {
                  e.target.style.background = '#334155';
                  e.target.style.color = '#f1f5f9';
                }
              }}
              onMouseLeave={(e) => {
                if (activePage !== btn.id) {
                  e.target.style.background = '#1e293b';
                  e.target.style.color = '#94a3b8';
                }
              }}
            >
              {btn.label}
            </button>
          ))}
        </div>

        {/* Mobile: Vertical layout - handled by CSS media query */}
        <style>{`
          @media (max-width: 640px) {
            .nav-desktop {
              flex-direction: column !important;
            }
            .nav-desktop button {
              width: 100% !important;
              min-width: unset !important;
            }
          }
        `}</style>
      </div>
    </div>
  );
}

export default SignalsNavigation;
